import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Success from './pages/Success';
import Cancel from './pages/Cancel';
import Donation from './components/Donation';
import ThankYouPage from './components/ThankYouPage';

const App = () => {
  const basename = process.env.NODE_ENV === 'development' ? '/' : '/lamdonate';
  return (
    <Router basename={basename}>
      <Routes>

      <Route path="/" element={<Donation />} />
      <Route path="/thank-you" element={<ThankYouPage />} />
      
       
        <Route path="/success" element={<Success />} />
        <Route path="/cancel" element={<Cancel />} />
        {/* Add a catch-all route for handling unmatched paths */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default App;
